import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API_URL } from '../../config/api';
import './CheckoutProcessingPage.css';

const CheckoutProcessingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processando seu pagamento...');

  useEffect(() => {
    const processPayment = async () => {
      try {
        console.log('🔍 CheckoutProcessingPage - URL completa:', window.location.href);
        console.log('🔍 CheckoutProcessingPage - location.search:', location.search);
        console.log('🔍 CheckoutProcessingPage - location.hash:', location.hash);
        
        // Extrair token da URL
        // O Pagar.me retorna: ?pagarmetoken=card_xxxxx
        const urlParams = new URLSearchParams(location.search);
        const token = urlParams.get('pagarmetoken');
        
        console.log('💳 Token recebido da Pagar.me:', token);
        
        if (!token) {
          console.error('❌ Token não encontrado na URL');
          setStatus('error');
          setMessage('Token de pagamento não encontrado. Tente novamente.');
          
          setTimeout(() => {
            navigate(-1); // Voltar para checkout
          }, 3000);
          return;
        }
        
        // Verificar se é fluxo de SaleCheckoutPaymentPage (pagamento de venda existente)
        const existingSaleId = localStorage.getItem('checkout-sale-id');

        if (existingSaleId) {
          // Fluxo: pagamento de venda existente via SaleCheckoutPaymentPage
          console.log('💳 Fluxo SaleCheckoutPaymentPage detectado, sale:', existingSaleId);
          const saleInstallments = parseInt(localStorage.getItem('checkout-sale-installments') || '1');

          setMessage('Processando pagamento com cartão de crédito...');

          const response = await fetch(`${API_URL}/api/sales/${existingSaleId}/process-payment`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              payment_method: 'credit_card',
              card_token: token,
              installments: saleInstallments
            })
          });

          const result = await response.json();
          console.log('Resposta do backend (sale):', result);

          // Limpar dados do fluxo sale
          localStorage.removeItem('checkout-sale-id');
          localStorage.removeItem('checkout-sale-installments');

          if (result.success) {
            setStatus('success');
            setMessage('Pagamento processado com sucesso!');

            setTimeout(() => {
              navigate('/checkout/success', {
                state: {
                  order: result.data,
                  payment_info: result.data.payment_info
                }
              });
            }, 2000);
          } else {
            setStatus('error');
            setMessage(result.error || 'Erro ao processar pagamento');

            setTimeout(() => {
              navigate(`/checkout-payment/${existingSaleId}`);
            }, 3000);
          }
          return;
        }

        // Fluxo original: checkout novo via LandingCheckout
        const savedData = localStorage.getItem('checkout-form-data');

        if (!savedData) {
          console.error('Dados do checkout não encontrados');
          setStatus('error');
          setMessage('Dados do checkout perdidos. Tente novamente.');

          setTimeout(() => {
            navigate(-1);
          }, 3000);
          return;
        }

        const formData = JSON.parse(savedData);
        console.log('Dados recuperados:', formData);

        // Recuperar dados do produto
        const productId = localStorage.getItem('checkout-product-id');
        const checkoutId = localStorage.getItem('checkout-checkout-id');
        const affiliateInfo = JSON.parse(localStorage.getItem('checkout-affiliate-info') || '{}');
        const totalAmount = parseInt(localStorage.getItem('checkout-total-amount') || '0');

        console.log('Dados da compra:', {
          productId,
          checkoutId,
          totalAmount,
          affiliateInfo
        });

        // Preparar payload para o backend
        const saleData = {
          product_id: parseInt(productId),
          customer_data: formData.customer,
          shipping_address: formData.shipping,
          affiliate_data: affiliateInfo,
          payment_method: 'credit_card',
          payment_data: {
            payment_token: token,
            card_token: token,
            installments: formData.payment.installments || 1
          },
          installments: formData.payment.installments || 1,
          total_amount: totalAmount,
          affiliate_id: affiliateInfo.affiliate_id || null,
          utm_source: affiliateInfo.utm_source || null
        };

        console.log('Enviando para backend:', saleData);

        setMessage('Processando pagamento com cartão de crédito...');

        const response = await fetch(`${API_URL}/api/checkout/process`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(saleData)
        });

        const result = await response.json();

        console.log('Resposta do backend:', result);

        if (result.success) {
          setStatus('success');
          setMessage('Pagamento processado com sucesso!');

          // Limpar dados salvos
          localStorage.removeItem('checkout-form-data');
          localStorage.removeItem('checkout-product-id');
          localStorage.removeItem('checkout-checkout-id');
          localStorage.removeItem('checkout-affiliate-info');
          localStorage.removeItem('checkout-total-amount');

          // Redirecionar para página de sucesso
          setTimeout(() => {
            navigate('/checkout/success', {
              state: {
                order: result.data,
                payment_info: result.data.payment_info
              }
            });
          }, 2000);
        } else {
          console.error('Erro ao processar pagamento:', result.message);
          setStatus('error');
          setMessage(result.message || 'Erro ao processar pagamento');

          setTimeout(() => {
            navigate(-1);
          }, 3000);
        }
        
      } catch (error) {
        console.error('❌ Erro ao processar pagamento:', error);
        setStatus('error');
        setMessage('Erro ao processar pagamento. Tente novamente.');
        
        setTimeout(() => {
          navigate(-1);
        }, 3000);
      }
    };
    
    processPayment();
  }, [location, navigate]);

  return (
    <div className="checkout-processing-page">
      <div className="processing-container">
        <div className={`processing-icon ${status}`}>
          {status === 'processing' && (
            <div className="spinner"></div>
          )}
          {status === 'success' && (
            <div className="success-icon">✓</div>
          )}
          {status === 'error' && (
            <div className="error-icon">✕</div>
          )}
        </div>
        
        <h2 className="processing-title">
          {status === 'processing' && 'Processando Pagamento'}
          {status === 'success' && 'Pagamento Aprovado!'}
          {status === 'error' && 'Erro no Pagamento'}
        </h2>
        
        <p className="processing-message">{message}</p>
        
        {status === 'processing' && (
          <p className="processing-subtitle">
            Aguarde enquanto confirmamos seu pagamento...
          </p>
        )}
      </div>
    </div>
  );
};

export default CheckoutProcessingPage;


